import { velocityPerSecond } from '@motionone/utils';
var sampleT = 5; // ms
function calcGeneratorVelocity(resolveValue, t, current) {
  var prevT = Math.max(t - sampleT, 0);
  return velocityPerSecond(current - resolveValue(prevT), t - prevT);
}
export { calcGeneratorVelocity };